import axios from "../../config/axios";

export const getAllFaq = () => axios.get("faqs");

export const getTermsAndConditions = () => axios.get("terms-conditions");

export const getPrivacyPolicy = () => axios.get("privacypolicy");



// WEBPACK FOOTER //
// ./src/services/requestors/cms.js